/* eslint-disable no-return-assign */
let overlayRef;
let contentRef;

export const setRefs = ({ overlay, content }) => {
  overlayRef = overlay;
  contentRef = content;
};

export const openPopup = ({ coordinate, content: { address, service_coverage, town } }) => {
  contentRef.innerHTML = `
    <div style="display: flex; flex-direction: column;">
      <p style="font-size: 12px; margin: 0; padding: 5px 10px">${address}, ${town}</p>
      <p style="font-size: 12px; margin: 0; padding: 5px 10px">${service_coverage}</p>
    </div>
  `;
  overlayRef.setPosition(coordinate);
};
